module.exports = __webpack_public_path__ + "img/logo.e4ef6f17.png";